import FormPages from "../../config/FormPages";
import {Will} from "../../model/Will";
import {validateBasicInformation} from "../page/BasicInformationValidator";
import {FormValidationErrors, ValidationError} from "../ValidationTypes";
import {EstateFlowchartState} from "../../model/EstateFlowchartTypes";

/**
 * Validates the form based on the current page and trust data.
 * @param {string} pageName - The current page name of the form being validated.
 * @param {Will} will - The trust data to validate against.
 * @param {EstateFlowchartState[]} flowcharts - The list of estate flowcharts for context in validation.
 * @returns {{formHasErrors: boolean, errors: any}} An object containing a boolean indicating if the form has errors and an object with the specific errors.
 */
export const validateForm = (
    pageName: string | undefined, 
    will: Will | undefined, 
    flowcharts: EstateFlowchartState[], 
    flowchartId: string, 
    enableEstateFlowchartMVPRelease: boolean
): FormValidationErrors => {
    let errors : ValidationError[] = [];

    if(will) {
        switch (pageName) {
            case FormPages.BASIC_INFORMATION.id:
                errors = validateBasicInformation(will, flowcharts, flowchartId, enableEstateFlowchartMVPRelease);
                break;
        }
    }

    return {
        formHasErrors: errors.length > 0,
        errors: errors
    };
}